import React, { useContext } from "react";
import "./productStyles.css";
import Dropzone from "../Dropzone";
import DropzoneSimple from "../DropzoneSimple";
import blackTextImage from "../assets/pbintBlackText.png";
import whiteTextImage from "../assets/pbintWhiteText.png";
import pWidgetImage from "../assets/pWidgetImage.png";
import DROPZONE_DATA from "../DROPZONE_DATA";
import OpacityContext from "../OpacityContext";
import "./productStyles.css"; //* migrate styles added by js for the products to this stylesheet

export default function P_bint({
  handleWarningMessageText,
  handleDropzoneChanges,
  handleContinueButtonDisabled
}) {
  const {
    bintBGOpacity,
    isBlackText,
    noBintImages,
    bintBGColor,
    pfdFile
  } = useContext(OpacityContext);
  const bintBGColorPre = bintBGColor;
  const bintBGColorLocal = "#" + bintBGColorPre;

  //* TODO move these styles to a css
  const bgStyle = {
    backgroundColor: bintBGColorLocal,
    opacity: bintBGOpacity,
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0
  };
  const bgImage = {
    position: "relative",
    zIndex: 100
  };

  return (
    <div className="portraitProductContainer">
      <div className="backgroundImageContainer portrait">
        <img
          style={bgImage}
          alt=""
          className="backgroundImage"
          src={isBlackText ? blackTextImage : whiteTextImage}
        ></img>
        <div style={bgStyle} className="backgroundColorContainer"></div>
      </div>
      {/* <div className="pStandardAd" style={pStandardAd}> */}
      <div className="pStandardAd">
        <Dropzone
          acceptedFileTypeString={DROPZONE_DATA.data.videoOnly}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="standardAd"
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>

      {/* I wonder why this one isn't pBintWidget? this doesn't seem to exsist so it's not quite built the same as LFD */}
      <div
        className={`pBint pBintAd ${noBintImages === false ? "hide" : ""}`}
        // style={pBint}
      >
        <img src={pWidgetImage} alt="back"></img>
      </div>

      <div
        className={`pBint pBintAd ${noBintImages === true ? "hide" : ""}`}
        // style={pBint}
      >
        <DropzoneSimple
          acceptedFileTypeString={DROPZONE_DATA.data.imageOnly}
          handleDropzoneChanges={handleDropzoneChanges}
          handleWarningMessageText={handleWarningMessageText}
          droppedFileType="portrait"
          assetFileToChange={pfdFile}
          handleContinueButtonDisabled={handleContinueButtonDisabled}
        />
      </div>
    </div>
  );
}
